import { DEBUG } from "./assets";
import * as events from "./core/events";
import { k } from "./core/kaplay";
import { spawnEntity } from "./core/registry";
import "./core/viewport";
import { assetsScene } from "./scenes/assets";
import { bootScene } from "./scenes/boot";
import { gameScene } from "./scenes/game";
import { menuScene } from "./scenes/menu";
import { mountainScene } from "./scenes/mountain";
import { resultsScene } from "./scenes/results";
import { settingsScene } from "./scenes/settings";
import { installFocusGuard } from "./ui/focusGuard";
import { registerObstacles } from "./entities/obstacles";
import { registerRamps } from "./entities/ramps";

k.scene("boot", bootScene);
k.scene("menu", menuScene);
k.scene("mountain", mountainScene);
k.scene("game", gameScene);
k.scene("results", resultsScene);
k.scene("settings", settingsScene);
if (DEBUG) k.scene("assets", assetsScene);

registerObstacles();
registerRamps();
if (DEBUG) Object.assign(window, { k, events, spawnEntity });
installFocusGuard();
k.go("boot");
